import { collection, addDoc, getDocs, doc, deleteDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { db, storage } from "../../../firebase"; // Configuración de Firebase

const productosCollection = "products";

// Subir producto a Firebase
export const uploadProduct = async (productData) => {
  const { name, description, price, imageFile } = productData;

  // Subir imagen al storage de Firebase
  const imageRef = ref(storage, `productos/${imageFile.name}`);
  await uploadBytes(imageRef, imageFile);
  const imageUrl = await getDownloadURL(imageRef);

  // Guardar datos en la colección de Firestore
  const productDoc = {
    name,
    description,
    price: parseFloat(price),
    imageUrl,
  };

  const docRef = await addDoc(collection(db, productosCollection), productDoc);
  return { id: docRef.id, ...productDoc };
};

// Obtener productos desde Firebase
export const getProducts = async () => {
  const querySnapshot = await getDocs(collection(db, productosCollection));
  return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

// Eliminar producto (de Firestore y Storage)
export const deleteProduct = async (id, imageUrl) => {
  // Eliminar de Firestore
  const docRef = doc(db, productosCollection, id);
  await deleteDoc(docRef);

  // Eliminar imagen del storage
  const imageRef = ref(storage, imageUrl);
  await deleteObject(imageRef);
};
